// extracted by mini-css-extract-plugin
export default {"dialogmainwrapper":"dialogProceduresAddUpdate_dialogmainwrapper__pu+sI","btns":"dialogProceduresAddUpdate_btns__FrKAk"};